import { Runtime } from "fp";

import React from "react";

import { NotApplicable as GenericNotApplicable } from "~/NotApplicable";
import { Order } from "~/Order";

export type Distance = { readonly distance: Distance.Miles };

export function Distance({
  NotApplicable = GenericNotApplicable,
  distance: { miles },
}: Distance.Props) {
  const milesFixed = parseFloat(miles.toFixed(1));
  return milesFixed > 0 ? (
    <>{milesFixed.toLocaleString()} mi</>
  ) : (
    <NotApplicable />
  );
}

export namespace Distance {
  export type Props = Distance & { readonly NotApplicable?: React.Fn };

  export namespace Response {
    export const runtime = () => Runtime.strict({ distance: Runtime.number() });
    export const decode = (
      response: Runtime.ToType<typeof runtime>
    ): Distance => ({ distance: { miles: response.distance } });
  }

  export type Miles = { readonly miles: number };
  export const { compare } = Order.fromCompare<Distance>((a, b) =>
    Order.number().compare(a.distance.miles, b.distance.miles)
  );
}
